/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'AutoplayVideo';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        let video;

        if (window.matchMedia("(min-width: 751px)").matches) {
            video = this.$el.data('src-big');
        } else {
            video = this.$el.data('src-small');
        }

        this.$el.attr('src', video);

        if (this.$el.data('autoplay')) {
            this.el.play();
        }
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
